import * as yup from 'yup';
import { Audio, AudioFormValidationProperties } from 'types/audio';
import { fieldValidationMessages } from 'app/constants';
import { Option } from 'types/general.types';

export const getDefaultValues = (options: Option[], audio?: Audio) => {
  const type = options.find((item) => item.value === audio?.type);
  return {
    title: audio?.title || '',
    type,
    remark: audio?.remark || '',
  };
};

export const getValidationSchema = (
  audioFormValidation: AudioFormValidationProperties
) =>
  yup.object().shape({
    title: yup
      .string()
      .required(fieldValidationMessages.REQUIRED)
      .max(
        audioFormValidation.title.maxLength,
        fieldValidationMessages.MAX_CHAR(audioFormValidation.title.maxLength)
      )
      .trim(),
    remark: yup
      .string()
      .max(
        audioFormValidation.remark.maxLength,
        fieldValidationMessages.MAX_CHAR(audioFormValidation.remark.maxLength)
      )
      .trim(),
    type: yup.object().required(fieldValidationMessages.REQUIRED),
  });
